import { render, staticRenderFns } from "./Mobanner.vue?vue&type=template&id=5e147c08&"
import script from "./Mobanner.vue?vue&type=script&lang=js&"
export * from "./Mobanner.vue?vue&type=script&lang=js&"
import style0 from "./Mobanner.vue?vue&type=style&index=0&id=5e147c08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports